import Medusa from '@adoratorio/medusa';
import animations from '@/assets/animations';

const medusa = {
  ref: null,

  init() {
    medusa.ref = new Medusa({
      targets: [{
        id: 'viewport',
        container: document.body,
        threshold: 0,
        nodes: [],
        mode: Medusa.MODE.DEFAULT,
        callback: medusa.callback,
        autoremove: false,
      }, {
        id: 'webgl-animations',
        container: document.body,
        threshold: 0,
        offsets: '0px 0px 0px 0px',
        nodes: [],
        mode: Medusa.MODE.ONCE,
        callback: medusa.webglAnimations,
        autoremove: false,
      }, {
        id: 'animations',
        container: document.body,
        threshold: 0,
        offsets: '0px 0px -300px 0px',
        nodes: [],
        mode: Medusa.MODE.ONCE,
        callback: medusa.animations,
        autoremove: false,
      }],
    });
  },

  callback(event) {
    if (event.isIntersecting) {
      event.target.dataset.inViewport = '';
    } else {
      delete event.target.dataset.inViewport;
    }
  },

  animations(event) {
    animations.get(`${event.target.dataset.medusaAnimation}-in`)(event.target);
  },

  webglAnimations(event) {
    window.dispatchEvent(new CustomEvent('webgl-in', { detail: { id: event.target.dataset.webglId } }));
  },

  addNodes(nodes) {
    nodes.forEach((node) => {
      window.dispatchEvent(new CustomEvent('webgl-initial', { detail: { id: node.dataset.webglId } }));
    });
    medusa.ref.pushToTarget('viewport', nodes);
    medusa.ref.pushToTarget('webgl-animations', nodes);
  },

  addHTMLNodes(nodes) {
    nodes.forEach((node) => {
      animations.get(`${node.dataset.medusaAnimation}-initial`)(node);
    });
    medusa.ref.pushToTarget('animations', nodes);
  },

  switchMode(nodes) {
    medusa.ref.pushToTarget('viewport', nodes);
  },
};

export default medusa;
